module.exports = __webpack_public_path__ + "img/icon-thisyear.754cdab9.png";